(() => {
	const vauchers = document.querySelector('.vouchers');

	if( !vauchers ) {
		return;
	}

	vauchers?.querySelectorAll('.button-action:not(.button-disabled)').forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			const id = item.dataset.id;
			const notes = prompt('Additional notes?');
			const href = item.getAttribute('href');
			const formData = new FormData();

			if (notes === null) {
				return;
			}

			formData.append('id', id);
			formData.append('notes', notes);

			item.classList.add('button-disabled');

			fetch(href, {
				headers: {
					'X-CSRF-TOKEN': document.querySelector('head meta[name="csrf-token"]')?.content,
				},
				method: "POST",
				body: formData
			}).then(res => res.text()).then(() => {
				window.location.reload();
			}).catch((error) => {
				console.log( error );

				alert('Something went wront.');
				item.classList.remove('button-disabled')
			})
		})
	})
})();
